import type { AuthUser } from '@/context/auth-context';
import { hasRequiredRole } from '@/types/user';

const MASTERDATA_WRITE_ROLES = new Set([
  'project.owner',
  'project.admin',
  'project.masterdata.write',
  'project.masterdata.review',
  'Administrator',
  'ProjectManager',
]);

export function hasMasterdataWritePermission(
  user: Pick<AuthUser, 'role' | 'roles'> | null | undefined,
) {
  if (!user) {
    return false;
  }

  if (hasRequiredRole(user.role, 'ProjectManager')) {
    return true;
  }

  return (user.roles ?? []).some((role) => MASTERDATA_WRITE_ROLES.has(role));
}
